import React from 'react';
import { Globe, MessageSquare, Mail, Phone, MessageCircle, Wifi, Facebook, Twitter } from 'lucide-react';
import { QRCodeType } from '../types/qr-types';
import { t } from '../i18n/translations';

interface QRTypeSelectorProps {
  selectedType: QRCodeType;
  onTypeChange: (type: QRCodeType) => void;
  language: 'en' | 'zh';
}

const iconMap: Record<QRCodeType, React.ReactNode> = {
  url: <Globe className="w-7 h-7 mb-2" />,
  text: <MessageSquare className="w-7 h-7 mb-2" />,
  email: <Mail className="w-7 h-7 mb-2" />,
  phone: <Phone className="w-7 h-7 mb-2" />,
  sms: <MessageCircle className="w-7 h-7 mb-2" />,
  wifi: <Wifi className="w-7 h-7 mb-2" />,
  facebook: <Facebook className="w-7 h-7 mb-2" />,
  twitter: <Twitter className="w-7 h-7 mb-2" />,
};

const labelMap: Record<QRCodeType, string> = {
  url: 'websiteUrl',
  text: 'textContent',
  email: 'email',
  phone: 'phoneNumber',
  sms: 'sms',
  wifi: 'wifi',
  facebook: 'facebook',
  twitter: 'twitter',
};

const QRTypeSelector: React.FC<QRTypeSelectorProps> = ({ selectedType, onTypeChange, language }) => {
  const types: QRCodeType[] = ['url', 'text', 'email', 'phone', 'sms', 'wifi', 'facebook', 'twitter'];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
      {types.map((type) => {
        const selected = selectedType === type;
        return (
          <button
            key={type}
            onClick={() => onTypeChange(type)}
            className={`flex flex-col items-center justify-center px-0 py-5 rounded-xl transition-all duration-200 shadow-md border-2 focus:outline-none
              ${selected ? 'bg-blue-600 text-white border-blue-500 shadow-lg scale-105' : 'bg-white/10 text-gray-200 border-transparent hover:bg-white/20 hover:text-white'}
            `}
            style={{ minHeight: 100 }}
          >
            {iconMap[type]}
            <span className="text-base font-medium mt-1 tracking-wide select-none">
              {t(labelMap[type], language)}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default QRTypeSelector;